var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5001 16.92V19.92C22.5012 20.1985 22.4441 20.4741 22.3326 20.7293C22.221 20.9845 22.0574 21.2136 21.8521 21.4018C21.6469 21.5901 21.4046 21.7335 21.1408 21.8227C20.877 21.9119 20.5974 21.945 20.3201 21.92C17.2429 21.5856 14.2871 20.5341 11.6901 18.85C9.27388 17.3146 7.22539 15.2661 5.69006 12.85C4.00003 10.2412 2.9483 7.27097 2.62006 4.17997C2.59507 3.90344 2.62793 3.62474 2.71656 3.3616C2.80518 3.09846 2.94763 2.85666 3.13482 2.6516C3.32202 2.44653 3.54986 2.28268 3.80385 2.1705C4.05783 2.05831 4.3324 2.00024 4.61006 1.99997H7.61006C8.09536 1.9952 8.56585 2.16705 8.93382 2.48351C9.30179 2.79996 9.54213 3.23942 9.61005 3.71997C9.73668 4.68004 9.97151 5.6227 10.3101 6.52997C10.4446 6.8879 10.4737 7.27689 10.394 7.65086C10.3142 8.02482 10.1289 8.36809 9.86005 8.63998L8.59006 9.90997C10.0136 12.4135 12.0865 14.4864 14.5901 15.91L15.8601 14.64C16.1319 14.3711 16.4752 14.1858 16.8492 14.1061C17.2231 14.0263 17.6121 14.0554 17.9701 14.19C18.8773 14.5285 19.82 14.7634 20.7801 14.89C21.2658 14.9585 21.7095 15.2032 22.0266 15.5775C22.3437 15.9518 22.5122 16.4296 22.5001 16.92Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d0e337af2628d2b3b8affcb5bfeb04ee.svg";
export { ForwardRef as ReactComponent };